import type { PropsWithChildren } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import Divider from 'LuxKit/Divider'

const Section = styled.div`
  display: grid;
  gap: ${rem(12)};
`

const Content = styled.div`
  display: grid;
  gap: ${rem(8)};
`

function AccommodationPackageCancellationSection({ children }: PropsWithChildren) {
  return <Section>
    <Divider kind="primary" />
    <Content>{children}</Content>
  </Section>
}

export default AccommodationPackageCancellationSection
